// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__37rZT","label":"LabeledBox_label__3fujV"};